<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center justify-content-between"
    > 
      Data Waiver
      <template v-if="role_status && role_status.status_create">
        <CButton color="success" class="btn-md" @click="createData">Tambah</CButton>
      </template>
      <template v-else>
        <CButton 
        color="secondary"
        style="float:right;margin-right:10px "
        class="btn-md ml-auto"
        disabled
        >Tambah</CButton>
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name="pageSize" id="pageSize" @change="changePageSize" v-model.number="pageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."              
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1: index + indexed + 1}}</td>
            </template>            
            <template #namaWaiver="{item}">
              <td class="py-2 font-weight-bold">{{item.namaWaiver ? item.namaWaiver : "-"}}</td>
            </template>
            <template #namaInstansi="{item}">
              <td class="py-2">{{item.namaInstansi ? item.namaInstansi : "-"}}</td>
            </template>
            <template #tanggalMulai="{item}">
              <td class="py-2">{{item.tanggalMulai ? item.tanggalMulai : "-"}}</td>
            </template>            
            <template #tanggalBerakhir="{item}">
              <td class="py-2">{{item.tanggalBerakhir ? item.tanggalBerakhir : "-"}}</td>
            </template>
            <template #jumlah_penerima="{item}">
              <td class="py-2 text-center">{{item.jumlah_penerima ? item.jumlah_penerima : "-"}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center"> 
                <template v-if="role_status && role_status.status_read">
                <router-link :to="`list-waiver/penerima-waiver/${item.idWaiver}`">
                  <CButton v-c-tooltip="'Penerima'" color="warning" square size="sm" class="text-white">
                    <font-awesome-icon icon="user" />
                  </CButton>
                </router-link>
                </template>&nbsp;&nbsp;&nbsp;
                <template v-else>
                <router-link :to="`list-waiver/penerima-waiver/${item.idWaiver}`" tag="button" :disabled="true">
                  <CButton v-c-tooltip="'Penerima'" color="secondary" square size="sm" class="text-white">
                    <font-awesome-icon icon="user" />
                  </CButton>
                </router-link>
                </template>&nbsp;&nbsp;&nbsp;
                <template v-if="role_status && role_status.status_update">
                  <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </template>&nbsp;&nbsp;
                <template v-else>
                 <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </template>&nbsp;&nbsp;
                <template v-if="role_status && role_status.status_delete">
                  <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>&nbsp;&nbsp;
                <template v-else>
                  <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>&nbsp;&nbsp;
                
              </td>
            </template>
          </CDataTable>
        <CPagination 
          style="float:right" 
          :active-page.sync="currentPage" 
          :pages="pagination.totalPages" 
          responsive 
        />
        </CCol>
      </CRow>      
    </CCardBody>    

    <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"        
        :centered="true"
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>          
        </template>
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12" class="mb-2">              
              <label for="nama" class="font-weight-bold">Nama Waiver</label>
              <input
                type="text"
                class="form-control"
                id="namaWaiver"
                required
                placeholder="Masukkan Nama Waiver"
                v-model="formData.namaWaiver"
                :class="{
                  'is-invalid': $v.formData.namaWaiver.$error,
                }"
              />                                               
            </CCol>

            <CCol sm="12" class="mb-2">              
              <label for="nama" class="font-weight-bold">Nama Instansi</label>
              <input
                type="text"
                class="form-control"
                id="namaInstansi"
                required
                placeholder="Masukkan Nama Instansi"
                v-model="formData.namaInstansi"
                :class="{
                  'is-invalid': $v.formData.namaInstansi.$error,                   
                }"
              />                                             
            </CCol>

            <CCol sm="12">              
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="nama" class="font-weight-bold">Tanggal Mulai</label>
                  <input 
                    type="date" 
                    class="form-control" 
                    id="tanggalMulai" 
                    required 
                    v-model="formData.tanggalMulai"
                    :min="today"
                    :class="{
                      'is-invalid': $v.formData.tanggalMulai.$error,
                    }"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="nama" class="font-weight-bold">Tanggal Berakhir</label>
                  <input 
                    type="date" 
                    class="form-control" 
                    id="tanggalBerakhir" 
                    required 
                    v-model="formData.tanggalBerakhir"
                    :min="today"
                    :class="{
                      'is-invalid': $v.formData.tanggalBerakhir.$error,                   
                    }"
                  />
                </div>
              </div>                                           
            </CCol>

            <CCol sm="12">
              <label for class="font-weight-bold">Status Waiver</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"                    
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                    aria-required="true"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>                
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { AlertUtils } from "@/mixins/AlertUtils";
import moment from 'moment';
import WaiverService from '@/services/rpl/waiver.service';

const fields = [
  {
    key: "no",
    sorter: true,
    filter: true
  },  
  {
    key: "namaWaiver",
    label: "Nama Waiver",
    sorter: true,
    filter: true,
    _style: "font-weight: bold"
  },  
  {
    key: "namaInstansi",
    label: "Nama Instansi",
    sorter: true,
    filter: true
  },
  {
    key: "tanggalMulai",
    label: "Tanggal Mulai",
    sorter: true,
    filter: true
  },
  {
    key: "tanggalBerakhir",
    label : "Tanggal Berakhir",
    _style: "text-align: center",
    _classes: 'text-center',
    sorter: true,
    filter: true
  },
  {
    key: "jumlah_penerima",   
    label : "Total Penerima", 
    _style: "text-align: center",
    sorter: true,
    filter: true
  },
  {
    key: "status", 
    label : "Status Waiver",    
    _style: "text-align: center",
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: true,
    filter: true
  }
];

export default {
  name: 'list-waiver',
  mixins: [AlertUtils],
  data() {
    return {
      items: [],            
      search: "",
      pageSize: 10,            
      pagination: {
        totalPages: 0
      },      
      fields,
      currentPage: 0,                        
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      title: "",
      myModal: false,
      actionPost: "",
      formData: {
        namaInstansi: '',
        namaWaiver: '',
        status: '',
        tanggalMulai: '',
        tanggalBerakhir: '',                
      },
      today: '',
      role_status : null
    }
  },

  validations: {
    formData: {
      namaInstansi: { required },
      namaWaiver: { required },
      status: { required },
      tanggalMulai: { required },
      tanggalBerakhir: { 
        required ,
        isAfterDate(val, { tanggalMulai }) {
          return new Date(val) > new Date(tanggalMulai);
        }
      },                
    }
  },

  mounted() {
    this.today = moment().format("YYYY-MM-DD");
    this.getData(this.currentPage, this.pageSize, this.search);   
    this.roleData();
  },
  watch: {    
    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search);
    },
    search: function(val) {
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function() {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
     
    },
    myModal: function() {
      if(this.myModal === false) {
        this.$v.$reset();
      }
    }
  },

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData(this.currentPage, pageSize, this.search);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },       

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      WaiverService.getDataWaiver(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();          
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";      
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";      
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {                   
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData();          
        }        
      } else if (this.actionPost == "update") {        
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }                
      }
    },

    insertData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      WaiverService.postDataWaiver(this.formData)
        .then((response) => {
          this.myModal = false;
          this.getData(this.currentPage - 1, this.pageSize, this.search)
          this.alertSuccess(response.data.message)
          loader.hide();
        })
        .catch((error) => {
          this.myModal = false;
          this.getData(this.currentPage - 1, this.pageSize, this.search)
          this.alertError(error.response.data.message);
          loader.hide();
        })
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      WaiverService.putDataWaiver(this.formData)
        .then((response) => {
          this.myModal = false;
          this.getData(this.currentPage - 1, this.pageSize, this.search)
          this.alertSuccess(response.data.message)
          loader.hide();
        })
        .catch((error) => {
          this.myModal = false;
          this.getData(this.currentPage - 1, this.pageSize, this.search)
          this.alertError(error.response.data.message);
          loader.hide();
        })
    },

    deleteData(item, index) {      
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            WaiverService.deleteDataWaiver(item)
              .then(response => {                
                this.alertSuccess(response.data.message);
                this.getData(this.currentPage - 1, this.pageSize, this.search);
                loader.hide();
              })
              .catch(error => {
                this.alertError(error.response.data.message);   
                this.getData(this.currentPage - 1, this.pageSize, this.search);        
                loader.hide();   
              });            
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>